// import { HorseService } from '@pingum/api-services';
import BarnService from '../../services/BarnService';
import * as types from './types';
import { dispatchNetworkRequest } from '../networkDispatcher';

export const requestAccessForHorse = (barnId, horseId, request) => (dispatch) => {
  const promise = BarnService.requestAccessForHorse(barnId, horseId, request);
  dispatchNetworkRequest({
    dispatch,
    requestType: types.ADD_HORSE_ACCESS_REQUEST_REQUESTED,
    successType: types.ADD_HORSE_ACCESS_REQUEST_SUCCESS,
    errorType: types.ADD_HORSE_ACCESS_REQUEST_ERROR,
    promise,
    defaultErrorMessage: 'There was a problem adding the request for the horse',
    responseName: 'request',
  });
  return promise;
};

export const updateRequestAccessForHorse = (barnId, horseId, requestId, request) => (dispatch) => {
  const promise = BarnService.updateRequestAccessForHorse(barnId, horseId, requestId, request);
  dispatchNetworkRequest({
    dispatch,
    requestType: types.UPDATE_HORSE_ACCESS_REQUEST_REQUESTED,
    successType: types.UPDATE_HORSE_ACCESS_REQUEST_SUCCESS,
    errorType: types.UPDATE_HORSE_ACCESS_REQUEST_ERROR,
    promise,
    defaultErrorMessage: 'There was a problem updating the request for the horse',
    responseName: 'updatedRequest',
  });
  return promise;
};

export const getMyBarnsHorseAccessRequests = (id, requestingBarn, page = 0, pageSize = 25, sort = '') => (dispatch) => {
  const promise = BarnService.getMyBarnsHorseAccessRequests(id, requestingBarn, page, pageSize, sort);
  dispatchNetworkRequest({
    dispatch,
    requestType: types.GET_HORSE_ACCESS_REQUESTS_REQUESTED,
    successType: types.GET_HORSE_ACCESS_REQUESTS_SUCCESS,
    errorType: types.GET_HORSE_ACCESS_REQUESTS_ERROR,
    promise,
    defaultErrorMessage: 'There was a problem loading horse access requests for your barn',
    responseName: 'horseAccessRequests',
  });
  return promise;
};
